export default {
  data() {
    return {
      // eslint-disable-next-line
      escalationOptions: [
        "NA",
        "KPI",
        "Reg",
        "Fault",
        "Trip",
        "Damage",
        "Leak",
        "Fire",
        "Incident"
      ]
    };
  }
};
